module.exports = __webpack_public_path__ + "img/Liputan-Image-5.66566e64.jpg";